<template>
  <wrap-container>
    <help-title title="Inversiones" />

    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Comunicate con el centro de atención especializado
        <strong>0800-666-4600</strong> de lunes a viernes de 9 a 18 hs.
      </help-list-item>
      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre inversiones en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/inversiones.html"
        />
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    ContactLink
  }
};
</script>
